import { render } from "./RxSignature.vue?vue&type=template&id=c8e7b5e4&scoped=true"
import script from "./RxSignature.vue?vue&type=script&lang=js"
export * from "./RxSignature.vue?vue&type=script&lang=js"

import "./RxSignature.vue?vue&type=style&index=0&id=c8e7b5e4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e7b5e4"]])

export default __exports__